import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import * as formulas from '../../services/formulas';

import './Formula.scss';

class Formula extends Component {
  get normalizeParams() {
    const formParams = this.props.formParams;

    for (let param in formParams) {
      formParams[param] = formParams[param].replace(',', '.')
    }
  }

  get formResult() {
    return formulas.profitPerPayUser(this.props.formParams);
  }

  convertParamValue = (value) => {
    return parseFloat(value.toString().replace(',', '.')).toString().replace('.', ',')
  }

  render() {
    const formParams = this.props.formParams;
    const result = parseFloat(this.formResult, 10);
    const { langs } = window;

    return (
      <div className="formula">
        <div className="formula__item formula__value formula__value_result">
          {
            Number.isFinite(result) ?
            <React.Fragment>
              { result.toString().replace('.', ',') } { langs.currencyText }.
            </React.Fragment> :
            <React.Fragment>
              0 { langs.currencyText }.
            </React.Fragment>
          }
        </div>
        <div className="formula__item formula__operation"> = </div>
        <div className="formula__item formula__symbol">-</div>
        <div className="formula__item formula__symbol">(</div>
        <div className="formula__item formula__value" data-name='CPC'>{ `${ this.convertParamValue(formParams.CPC) } ${ langs.currencySymbol }` || `0 ${ langs.currencySymbol }` }</div>
        <div className="formula__item formula__operation">/</div>
        <div className="formula__item formula__value" data-name='CR1'>{ `${ this.convertParamValue(formParams.CR1) } %` || '0 %' }</div>
        <div className="formula__item formula__operation">/</div>
        <div className="formula__item formula__value" data-name='CR2'>{ `${ this.convertParamValue(formParams.CR2) } %` || '0 %' }</div>
        <div className="formula__item formula__symbol">)</div>
        <div className="formula__item formula__operation">+</div>
        <div className="formula__item formula__symbol">(</div>
        <div className="formula__item formula__value" data-name='AvP'>{ `${ this.convertParamValue(formParams.AvP) } ${ langs.currencySymbol }` || `0 ${ langs.currencySymbol }` }</div>
        <div className="formula__item formula__operation">-</div>
        <div className="formula__item formula__value" data-name='COGS'>{ `${ this.convertParamValue(formParams.COGS) } ${ langs.currencySymbol }` || `0 ${ langs.currencySymbol }` }</div>
        <div className="formula__item formula__symbol">)</div>
        <div className="formula__item formula__operation">x</div>
        <div className="formula__item formula__value" data-name='Ret'>{ this.convertParamValue(formParams.Ret) || 0 }</div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const formParams = getFormValues('profit')(state) || {};
  const { language } = state;

  return {
    formParams,
    currentLang: language.current
  }
}

export default connect(mapStateToProps)(Formula);


// WEBPACK FOOTER //
// ./src/components/Formula/Formula.js